import {
	axios,
} from './services/axios-service';

const permissionDirective = {
	install:
		async (app) => {
			if (document.head.querySelector('meta[name="user-id"]').content !== '') {
				await axios.get('/api/v0/permissions/current')
					.then((success) => {
						localStorage.setItem('permissions', JSON.stringify(success.data));
					}).catch((error) => {
						window.captureException(error);
						localStorage.setItem('permissions', JSON.stringify([]));
					});
			} else {
				localStorage.setItem('permissions', JSON.stringify([]));
			}
			app.directive('can', {
				/**
				 *
				 * @param {Element} el
				 * @param {object} binding
				 * @param {object} vnode
				 */
				beforeMount: function (el, binding, vnode) {
					if (!JSON.parse(localStorage.getItem('permissions'))
						.includes(binding.value
							.replace(/'/g, '')
							.replace(/"/g, ''))) {
						vnode.el.style.display = 'none';
					}
				}
			});
		}

};

export default permissionDirective;

